export enum GameState{
	InGame,
	ReadyToPlay,
	SelectGame,
}